import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider
} from 'react-router-dom';
import LoginPage from './pages/login';
import { ProfileView } from './pages/profile';
import PrincipalMenu from './pages/schoolsDinam';
import GroupPage from './pages/beneficiariesGroup';
import MeetingsList from './pages/meetingsList';
import SingleMeeting from './pages/singleMeeting';
import Characterization from './pages/characterization';
import AdminSchoolMenu from './pages/adminSchoolsMenu';
import AdminSchools from './pages/adminSchools';
import UserListAdmin from './pages/usersListAdmin';
import RootLayout from './layouts/rootLayout';
import AdminMenu from './pages/adminMenu';
import UsersRolAdmin from './pages/usersRolAdmin';
import CharacterizationAdmin from './pages/characterizationAdmin';
import BeneficiariesAdmin from './pages/beneficiariesAdmin';
import { UserNameProvider } from './contexts/userName';
import { LoaderProvider } from './contexts/loader/loader';
import Assistence from './pages/asistenceAdmin';
import SingleAssistence from './pages/singleAssistence';
import ErrorComponent from './pages/errorComponent';

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path='/' element={<RootLayout />}>
        <Route path='/login' element={<LoginPage />} />
        <Route index element={<ProfileView />} />
        <Route path='/escuelas' element={<PrincipalMenu />} />
        <Route path='/escuelas/grupo' element={<GroupPage />} />
        <Route
          path='/escuelas/grupo/:groupParam/school/:schoolParam'
          element={<GroupPage />}
        />
        <Route
          path='/escuelas/grupo/lista_de_encuentros'
          element={<MeetingsList />}
        />
        <Route
          path='/escuelas/grupo/lista_de_encuentros/encuentro'
          element={<SingleMeeting />}
        />
        <Route path='/caracterizacion' element={<Characterization />} />
        <Route
          path='/caracterizacion/:paramValue'
          element={<Characterization />}
        />
        <Route
          path='/caracterizacion/edit/:bid'
          element={<Characterization />}
        />
        <Route
          path='/caracterizacion/:paramValue/school/:schoolParam/group/:groupParam'
          element={<Characterization />}
        />
        <Route path='/administrador' element={<AdminSchoolMenu />} />
        <Route path='/administrador/menu' element={<AdminMenu />} />

        <Route path='/administrador/menu/escuelas' element={<AdminSchools />} />
        <Route path='/administrador/usuarios' element={<UsersRolAdmin />} />
        <Route
          path='/administrador/menu/caracterizacion'
          element={<CharacterizationAdmin />}
        />
        <Route
          path='/administrador/menu/asistencias'
          element={<Assistence />}
        />
        <Route
          path='/administrador/menu/asistencias/encuentro'
          element={<SingleAssistence />}
        />
        <Route
          path='/administrador/menu/escuelas/beneficiarios_inscritos'
          element={<UserListAdmin />}
        />
        <Route
          path='/administrador/menu/caracterizacion/ver_beneficiarios'
          element={<BeneficiariesAdmin />}
        />
        <Route errorElement={<ErrorComponent />} />
      </Route>
    )
  );

  return (
    <UserNameProvider>
      <LoaderProvider>
        <RouterProvider router={router} />
      </LoaderProvider>
    </UserNameProvider>
  );
}

export default App;
